import {
  IGrantForAllStudentsInProgress,
  IGrantForAllStudentsInProgressState,
} from '../Interfaces/IGrantForAllStudentsInProgress';
import { IAction } from '../../../../../__core/Interfaces/IAction';
import { grantForAllStudentsInProgressInitState } from './InitState';
import SHARING_ACTIONS from '../Actions/ActionTypes';

export const grantForAllStudentsInProgress = (
  state: IGrantForAllStudentsInProgressState = grantForAllStudentsInProgressInitState,
  action: IAction<IGrantForAllStudentsInProgress>
): IGrantForAllStudentsInProgressState => {
  switch (action.type) {
    case SHARING_ACTIONS.GRANT_FOR_ALL_STUDENTS_IN_PROGRESS_SET: {
      const counter = state.counter + 1;
      return { ...action.payload, counter };
    }

    case SHARING_ACTIONS.GRANT_FOR_ALL_STUDENTS_IN_PROGRESS_CLEAR:
      return { ...grantForAllStudentsInProgressInitState };
    default:
      return state;
  }
};
